import useData from "./useData";

const useWork = () => {
  const { addToWorkQueue } = useData();

  const submitWork = async (workType, details) => {
    const results = await addToWorkQueue(workType, details);

    return results;
  };

  const queueWork = async ({ workerType, details }) => {
    const results = await addToWorkQueue(workerType, details);
    return results;
  };

  return {
    submitWork,
    queueWork,
  };
};

export default useWork;
